export default "__VITE_ASSET__6aa07835__"